import React from "react";
import BasePage from "../base/BasePage";
import label from "enqc-utilities/src/label/Label";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {Button, ButtonGroup, Card, Col, Dropdown, Image, Row, Table} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faPlay, faTasks, faUser} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../../components/input/SearchInput";
import {navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import PaginationTable from "../../components/PaginationTable";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {toasting} from "../base/BaseComponent";
import InfiniteScroll from "react-infinite-scroll-component";
import {ASSEMBLY_STATUS_COLOR} from "enqc-utilities/src/utils/Global";
import AssemblyDetailModal from "../../components/AssemblyDetailModal";
import ContinueAssemblyConfirmationModal from "../../components/ContinueAssemblyConfirmationModal";
import AssemblyFormControlPage from "../business/AssemblyFormControlPage";
import UserDetailInformationModal from "../../components/UserDetailInformationModal";
import PublishedModelModal from "../../components/PublishedModelModal";
import ModelDetailInformationModal from "../../components/ModelDetailInformationModal";
import CreateAssemblyModal from "../../components/CreateAssemblyModal";
import CreateAssemblyConfirmationModal from "../../components/CreateAssemblyConfirmationModal";
import AssemblyDetailPage from "../business/AssemblyDetailPage";
import AssemblySelectionModal from "../../components/AssemblySelectionModal";
import AssemblyFromFindInspectionModal from "../../components/AssemblyFromFindInspectionModal";
import CreateAssemblyFromInspectionConfirmationModal
    from "../../components/CreateAssemblyFromInspectionConfirmationModal";


class DashboardPage extends BasePage{

    constructor(props) {
        super(props);
        let userAdminDashboardSummary = {}
        this.state = {
            yourAssemblies : [],
            assemblies : [],
            lookupAssemblies : [],
            ascending: "false",
            sortir: "ay.created",
            search: '',
            page: 1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            yourAssembliesPage: 1,
            totalPageOfYourAssemblies:0,
            totalElementOfYourAssemblies:0,
            pageElementOfYourAssemblies:0,
            hasMoreYourAssemblies:true,
            assemblyDetailModal:false,
            selectedAssembly:{},
            continueAssemblyConfirmationModal:false,
            selectedUser:{},
            userInformationModal:false,
            publishedModelModal:false,
            selectedModel:{},
            modelDetailInformationModal:false,
            createAssemblyModal:false,
            createAssemblyConfirmationModal:false,
            inputReference:'',
            lookupAssemblyModal:false,
            assemblyFromFindInspectionModal:false,
            foundInspection:{},
            createAssemblyFromInspectionConfirmationModal:false
        }
    }

    async componentDidMount() {
        super.componentDidMount();
        if(this.props?.navBar?.current){
            this.props.navBar.current.updateNavBarItems([])
        }
        this.props.closePreLoader()
        await this.fetchYourAssemblies(this.state.yourAssembliesPage)
        await this.fetchAssemblies()
    }

    fetchAssemblies = async () => {
        let {search, page, sortir, ascending} = this.state
        let params = {
            params :{
                ascending: ascending,
                sortir: sortir,
                search: search,
                page: page - 1,
            }
        }
        let response = await this.asyncGet(Endpoint.API.ASSEMBLIES_ONGOING, params, null,  true, true)
        if(!response){
            toasting.error(label.SomethingUnexpected)
            return
        }
        if(response.code===200){
            let assemblies = response.data
            let totalPage = response.totalPage
            let totalElement = response.totalElement
            let pageElement = response.pageElement
            this.setState({assemblies:assemblies, totalPage, totalElement, pageElement})
        }else{
            toasting.error(response.message)
        }
    }

    fetchMoreOfYourAssemblies = async () =>{
        let {yourAssembliesPage} = this.state
        yourAssembliesPage += 1;
        await this.fetchYourAssemblies(yourAssembliesPage)
    }

    fetchYourAssemblies = async (page) => {
        let {search} = this.state
        let params = {
            params :{
                ascending: false,
                sortir: "jah.updated",
                search: search,
                page: page - 1,
            }
        }
        let response = await this.asyncGet(Endpoint.API.YOUR_ASSEMBLY_HISTORIES, params, null, true, true)
        if(!response){
            toasting.error(label.SomethingUnexpected)
            return
        }
        if(response.code===200){
            let yourAssembliesPage = this.state.yourAssembliesPage
            let nextYourAssemblies = response.data
            let totalPageOfYourAssemblies = response.totalPage
            let totalElementOfYourAssemblies = response.totalElement
            let pageElementOfYourAssemblies = response.pageElement
            let hasMoreYourAssemblies = nextYourAssemblies.length>0
            if(hasMoreYourAssemblies){
                yourAssembliesPage = page;
            }
            let {yourAssemblies} = this.state
            this.setState({yourAssemblies:[...yourAssemblies, ...nextYourAssemblies], yourAssembliesPage, totalPageOfYourAssemblies, totalElementOfYourAssemblies, pageElementOfYourAssemblies, hasMoreYourAssemblies})
        }else{
            toasting.error(response.message)
        }
    }

    fetchAssemblyDetail(reference){
        this.showPostProgress()
        this.get(Endpoint.API.ASSEMBLY, {
            params :{
                reference : reference
            }
        }, null, response=>{
            if(response.code===200){
                let selectedAssembly = response.data
                this.setState({
                    selectedAssembly, assemblyDetailModal:true
                }, () => {
                    this.closePostProgress()
                })
            }
        }, false, true)
    }

    fetchModelDetail = (id) => {
        this.showPostProgress()
        this.get(Endpoint.API.MODEL, {
            params :{
                id : id
            }
        }, null, response=>{
            this.closePostProgress()
            if(response.code===200){
                let model = response.data
                this.setState({selectedModel:model, modelDetailInformationModal:true})
            }
        }, true, true)
    }

    searchAssemblies = (search) => {
        this.get(Endpoint.API.ASSEMBLIES_SEARCH, {
            params :{
                search : search
            }
        }, null, response=>{
            if(response.code===200){
                let lookupAssemblies = response.data
                let lookupAssemblyModal = (lookupAssemblies && lookupAssemblies.length > 0) ;
                this.setState({lookupAssemblies, lookupAssemblyModal:lookupAssemblyModal}, () => {
                    if(!lookupAssemblyModal){
                        toasting.error(label.RecordNotFound)
                    }
                })
            }
        }, true, false)
    }



    render () {
        let {assemblies, page, totalPage, pageElement, totalElement, yourAssembliesPage, totalPageOfYourAssemblies, totalElementOfYourAssemblies, pageElementOfYourAssemblies,
            yourAssemblies, hasMoreYourAssemblies, assemblyDetailModal, selectedAssembly, continueAssemblyConfirmationModal, selectedUser, userInformationModal, publishedModelModal,
            selectedModel, modelDetailInformationModal, createAssemblyModal, createAssemblyConfirmationModal, inputReference, lookupAssemblyModal, lookupAssemblies, assemblyFromFindInspectionModal,
            foundInspection, createAssemblyFromInspectionConfirmationModal}= this.state
        if(!assemblies){
            assemblies = []
        }
        if(!yourAssemblies){
            yourAssemblies = []
        }
        let {model} = selectedAssembly
        if(!model){
            model = {}
        }
        return (
            <>
                {super.render()}
                <AssemblyDetailModal
                    assembly={selectedAssembly}
                    show={assemblyDetailModal}
                    onContinueAssembly={(selectedAssembly) => {
                        this.setState({assemblyDetailModal:false, continueAssemblyConfirmationModal:true, selectedAssembly})
                    }}
                    onClose={() => {
                        this.setState({assemblyDetailModal:false, selectedAssembly:{}})
                    }}/>

                <ContinueAssemblyConfirmationModal
                    postProcessingRef={this.props.postProcessingRef}
                    show={continueAssemblyConfirmationModal}
                    model={model}
                    assembly={selectedAssembly}
                    reference={selectedAssembly.reference}
                    onClose={() => {
                        this.setState({continueAssemblyConfirmationModal:false})
                    }}
                    onResult={(assembly) => {
                        this.setState({continueAssemblyConfirmationModal:false, selectedAssembly:{}}, () => {
                            navigate(this.props, AssemblyFormControlPage.ENDPOINT+"?reference="+assembly.reference)
                        })
                    }}/>
                <UserDetailInformationModal
                    {...this.props}
                    user={selectedUser}
                    show={userInformationModal}
                    onClose={() => {
                        this.setState({userInformationModal:false, selectedUser:{}})
                    }}/>
                <PublishedModelModal
                    {...this.props}
                    show={publishedModelModal}
                    onSelect={(model) => {
                        this.setState({publishedModelModal:false}, () => {
                            this.fetchModelDetail(model.id)
                        })
                    }}
                    onClose={() => {
                        this.setState({publishedModelModal:false})
                    }}/>
                <ModelDetailInformationModal
                    enableCreateAssembly={true}
                    model={selectedModel}
                    show={modelDetailInformationModal}
                    onCreateAssembly={(selectedModel) => {
                        this.setState({createAssemblyModal:true, modelDetailInformationModal:false, selectedModel})
                    }}
                    onClose={() => {
                        this.setState({modelDetailInformationModal:false, selectedModel:{}})
                    }}/>
                <CreateAssemblyModal
                    {...this.props}
                    show={createAssemblyModal}
                    model={selectedModel}
                    onClose={() => {
                        this.setState({createAssemblyModal:false, selectedModel:{}})
                    }}
                    onResult={(reference, model) => {
                        this.setState({createAssemblyModal:false, createAssemblyConfirmationModal:true, inputReference:reference, selectedModel:model})
                    }}
                />
                <CreateAssemblyConfirmationModal
                    {...this.props}
                    show={createAssemblyConfirmationModal}
                    reference={inputReference}
                    model={selectedModel}
                    onClose={() => {
                        this.setState({createAssemblyConfirmationModal:false, inputReference:'', selectedModel:{}})
                    }}
                    onResult={(assembly) => {
                        this.setState({createAssemblyConfirmationModal:false, inputReference:'', selectedModel:{}}, () => {
                            toasting.info(label.SuccessfullyUpdatingNewData)
                            navigate(this.props, AssemblyDetailPage.ENDPOINT+"?reference="+assembly.reference)
                        })
                    }}
                />
                <AssemblySelectionModal
                    assemblies={lookupAssemblies}
                    show={lookupAssemblyModal}
                    onClose={() => {
                        this.setState({lookupAssemblyModal:false, lookupAssemblies:[]})
                    }}
                    onSelect={(selectedAssembly) => {
                        this.setState({lookupAssemblyModal:false, lookupAssemblies:[]}, () => {
                            this.fetchAssemblyDetail(selectedAssembly.reference)
                        })
                    }}/>
                <AssemblyFromFindInspectionModal
                    {...this.props}
                    show={assemblyFromFindInspectionModal}
                    onClose={() => {
                        this.setState({assemblyFromFindInspectionModal:false})
                    }}
                    onSearchResult={(inspection) => {
                        this.setState({foundInspection:inspection, assemblyFromFindInspectionModal:false, createAssemblyFromInspectionConfirmationModal:true})
                    }}/>
                <CreateAssemblyFromInspectionConfirmationModal
                    {...this.props}
                    show={createAssemblyFromInspectionConfirmationModal}
                    inspection={foundInspection}
                    onResult={(assembly) => {
                        this.setState({createAssemblyFromInspectionConfirmationModal:false, foundInspection:{}}, () => {
                            toasting.info(label.SuccessfullyUpdatingNewData)
                            navigate(this.props, AssemblyDetailPage.ENDPOINT+"?reference="+assembly.reference)
                        })
                    }}
                    onClose={() => {
                        this.setState({createAssemblyFromInspectionConfirmationModal:false, foundInspection:{}})
                    }}/>
                <Row>
                    <Col md={5} sm={12} className="mb-4 align-content-center">
                        <Dropdown
                            as={ButtonGroup}>
                            <Button size="sm" variant="outline-info">{label.CreateNewAssembly}</Button>
                            <Dropdown.Toggle size="sm" split variant="outline-info" id="dropdown-split-basic">
                                <FontAwesomeIcon icon={faCaretDown} className="me-1" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={event => {
                                        event.preventDefault()
                                        this.setState({publishedModelModal:true})
                                    }}>
                                        {label.CreateFromScratch}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={event => {
                                        event.preventDefault()
                                        this.setState({assemblyFromFindInspectionModal:true})
                                    }}>
                                    {label.GenerateFromInspection}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <Col md={7} sm={12} className="mb-4">
                        <SearchInput
                            placeholder={label.QuickLookupEnterAReference_InspectionSerialNumber_ComponentSerial_Number}
                            onEnter={(value) => {
                                this.searchAssemblies(value)
                            }}
                            onEmpty={() => {

                            }}/>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col md={8} sm={12} className="mb-3">
                        <Card>
                            <Card.Header className="p-3 bg-light fw-bolder">
                                {label.OnGoingAssemblies}
                            </Card.Header>
                            <Card.Body className="p-0 border-bottom">
                                <Table size="sm" className="table-sm align-items-center p-0 table-borderless">
                                    <tbody>
                                    {assemblies.length<=0?(
                                        <div className="w-100 h-100 text-center align-content-center justify-content-center align-items-center" style={{minHeight:'200px'}}>
                                            <Image
                                                className="p-1"
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    objectFit: 'cover',
                                                    opacity: 0.2,
                                                    filter : 'blur(1px)'
                                                }}
                                                src={ApplicationIcons.Icons.emptyBox}/>
                                            <br/>
                                            <span>Empty data..</span>
                                        </div>
                                    ):(
                                        <React.Fragment>
                                            {assemblies.map((item, index)=>{
                                                return(
                                                    <React.Fragment>
                                                        <Card className="p-2">
                                                            <Card.Body
                                                                style={{backgroundColor:(index+1)%2>0?"#f5f1ea":"#00000000", cursor:'pointer'}}
                                                                className="card-body-table"
                                                                onClick={event => {
                                                                    event.preventDefault()
                                                                    this.fetchAssemblyDetail(item.reference)
                                                                }}>
                                                                <tr>
                                                                    <td style={{whiteSpace:'nowrap', width:'8%'}} rowSpan="3" className="p-1 text-center align-items-center align-content-center fs-9 fw-bold text-white ps-2 pe-2 rounded-start bg-primary">
                                                                        #{((page - 1) * pageElement) + (index+1)}
                                                                    </td>
                                                                    <td className="p-1"><span className="text-info fw-bolder fs-6">{item.reference}</span></td>
                                                                    <td className="text-right text-italic text-green fw-bolder p-1 pe-2 fs-9">{parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-left text-wrap p-1" colSpan="2">
                                                                        <span
                                                                            className="fw-bolder font-small fs-6"
                                                                            style={{color:(item.assemblyStatus?ASSEMBLY_STATUS_COLOR[item.assemblyStatus.name]:undefined)}}>
                                                                        ({item.assemblyStatus?label(item.assemblyStatus.label):"-"})
                                                                        </span>
                                                                        <br/>
                                                                        <span className="text-dark fw-bolder text-wrap fs-7">{item.model?item.model.systemType:""}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="p-1">
                                                                        {label.PN}:<span className="text-info fs-8">{item.model?item.model.partNumber:""}</span>
                                                                    </td>
                                                                    <td className="text-right p-1" style={{whiteSpace:'nowrap'}}>
                                                                        <Button
                                                                            className="btn-outline-info"
                                                                            variant="outline-info" size="sm"
                                                                            onClick={e => {
                                                                                e.stopPropagation()
                                                                                this.showPostProgress()
                                                                                this.fetchUserInformation(item.user.id, (user)=>{
                                                                                    this.closePostProgress()
                                                                                    this.setState({userInformationModal:true, selectedUser:user})
                                                                                })
                                                                            }}>
                                                                            <FontAwesomeIcon size="sm" icon={faUser}/>
                                                                            &nbsp;
                                                                            {item.user?item.user.firstname+" / "+item.user.manufacturingSite.name:""}
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            </Card.Body>
                                                        </Card>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </React.Fragment>
                                    )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <div className="p-2 p-md-0">
                                <PaginationTable
                                    onSelect={(page) => {
                                        // this.goToPage(page)
                                        this.setState({page}, () => this.fetchAssemblies())
                                    }}
                                    showingRow={assemblies.length}
                                    currentPage={page}
                                    pageCount={totalPage}
                                    totalElement={totalElement}/>
                            </div>
                        </Card>
                    </Col>
                    <Col md={4} sm={12} className="mb-3 d-flex flex-column h-100">
                        <Card className="flex-grow-1 d-flex flex-column">
                            <Card.Header className="p-2 text-center bg-light">
                                {label.YourAssembly}
                            </Card.Header>
                            <Card.Body className="flex-grow-1 p-0">
                                {yourAssemblies.length==0?(
                                    <div className="w-100 h-100 text-center align-content-center justify-content-center align-items-center" style={{minHeight:'600px'}}>
                                        <Image
                                            className="p-1"
                                            style={{
                                                width: '150px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                opacity: 0.2,
                                                filter : 'blur(1px)'
                                            }}
                                            src={ApplicationIcons.Icons.emptyBox}/>
                                        <br/>
                                        <span>Empty data..</span>
                                    </div>
                                ):(
                                    <InfiniteScroll
                                        style={{padding:'0px'}}
                                        className="p-0 w-100"
                                        dataLength={yourAssemblies.length}
                                        next={this.fetchMoreOfYourAssemblies}
                                        hasMore={hasMoreYourAssemblies}
                                        loader={""}
                                        endMessage={<p className="text-center text-muted mt-2">No more items</p>}>
                                    <Table size="sm" className="table-sm align-items-center p-0 table-borderless">
                                        <tbody className="m-0 p-0">
                                                {yourAssemblies.map((item, index)=>{
                                                    return (
                                                        <React.Fragment>
                                                            <tr className="p-0" style={{backgroundColor:(index+1)%2>0?"#f1f0f5":"#00000000"}}>
                                                                <td className="ps-2 pt-2 pe-2">
                                                                    #{((yourAssembliesPage - 1) * pageElementOfYourAssemblies) + (index+1)}
                                                                    &nbsp;&nbsp;
                                                                    <span
                                                                        className="fw-normal font-small"
                                                                        style={{color:(item.assemblyStatus?ASSEMBLY_STATUS_COLOR[item.assemblyStatus.name]:undefined)}}>
                                                                        ({item.assemblyStatus?label(item.assemblyStatus.label):"-"})
                                                                    </span>
                                                                </td>
                                                                <td className="ps-2 pt-2 pe-2 text-right text-italic font-small">
                                                                    {parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                                                </td>
                                                            </tr>
                                                            <tr className="p-0" style={{backgroundColor:(index+1)%2>0?"#f1f0f5":"#00000000"}}>
                                                                <td className="ps-2 pt-0 pe-2">
                                                                    <span className="fw-bolder font-base">{item.reference}</span>
                                                                </td>
                                                                <td className="ps-2 pt-0 pe-2 text-info text-right">
                                                                    <span className="text-info">
                                                                        <FontAwesomeIcon size="sm" icon={faUser}/>
                                                                        &nbsp;
                                                                        {item.user?item.user.firstname+" / "+item.user.manufacturingSite.name:""}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr className="p-0" style={{backgroundColor:(index+1)%2>0?"#f1f0f5":"#00000000"}}>
                                                                <td className="ps-2 pt-0 pe-2" colSpan="2">
                                                                    <span className="fw-bolder font-small text-wrap">{item.model?item.model.systemType:""}</span>
                                                                    <br/>
                                                                    {label.PN}:<span className="text-italic">{item.model?item.model.partNumber:""}</span>
                                                                </td>
                                                            </tr>
                                                            <tr className="p-0 border-bottom" style={{backgroundColor:(index+1)%2>0?"#f1f0f5":"#00000000"}}>
                                                                <td className="p-2" colSpan="2">
                                                                    <Button
                                                                        className="w-100 bg-white text-info"
                                                                        size="sm"
                                                                        variant="info"
                                                                        onClick={e => {
                                                                            e.preventDefault()
                                                                            this.fetchAssemblyDetail(item.reference)
                                                                        }}>
                                                                        <FontAwesomeIcon size="sm" icon={faTasks}/>
                                                                        &nbsp;&nbsp;
                                                                        {label.View}
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    )
                                                })}
                                        </tbody>
                                    </Table>
                                    </InfiniteScroll>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    };
}

// export default Object.assign(DashboardOverview, {MAIN_ENDPOINT : "/", ENDPOINT : "/dashboard"})

const MAIN_ENDPOINT = "/"
const ENDPOINT = "/"
const TITLE = label.Dashboard
const PAGE = {MAIN_ENDPOINT: MAIN_ENDPOINT, ENDPOINT: ENDPOINT, PAGE_CONF: {MAIN_ENDPOINT, ENDPOINT, TITLE}}

export default Object.assign(DashboardPage, PAGE)


